import { TActivityTypeFilter } from "~/interfaces";
import { node } from "~/util/dom";

export function createSelectItem(type: TActivityTypeFilter) {
	const labelElement = node("label", { className: "ui-activity-select-item" });
	const input = node("input", { type: "radio", name: "activity", value: type });

	labelElement.appendChild(input);

	return labelElement;
}
